/* ============================================================
 * AYU Landing Page – Sacred Modern Design
 * "Neuzeit trifft Jahrtausende"
 *
 * Design: Warm darkness as stage, gold + olive & ivory glow
 * Protagonist: Annam Hanfstein
 * Typography: Playfair Display (display) + DM Sans (body)
 * Colors: Deep Saffron, Sacred Olive, Midnight Temple, Warm Ivory
 * ============================================================ */

import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import WasIstAyuSection from "@/components/WasIstAyuSection";
import VideoSection from "@/components/VideoSection";
import AyurvedaSection from "@/components/AyurvedaSection";
import PhenotypSection from "@/components/PhenotypSection";
import ZweiWegeSection from "@/components/ZweiWegeSection";
import KompassSection from "@/components/KompassSection";
import TagebuchSection from "@/components/TagebuchSection";
import AnnamSection from "@/components/AnnamSection";
import BuchTeaser from "@/components/BuchTeaser";
import WorkshopSection from "@/components/WorkshopSection";
import BetreuerSection from "@/components/BetreuerSection";
import TargetGroupSection from "@/components/TargetGroupSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FaqSection from "@/components/FaqSection";
import CtaSection from "@/components/CtaSection";
import Footer from "@/components/Footer";
import FaqChatWidget from "@/components/FaqChatWidget";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <WorkshopSection />
      <WasIstAyuSection />
      <VideoSection />
      <AyurvedaSection />
      <PhenotypSection />
      <ZweiWegeSection />
      <KompassSection />
      <TagebuchSection />
      <AnnamSection />
      <BuchTeaser />
      <BetreuerSection />
      <TargetGroupSection />
      <TestimonialsSection />
      <FaqSection />
      <CtaSection />
      <Footer />
      <FaqChatWidget mode="homepage" />
    </div>
  );
}
